(function ($) {
    $(document).ready(function () {
        // if($(".three-col-hoverable").length > 0){
            setTimeout(function () {
            $(".three-col-hoverable .col-three").each(function () {
                var title = $(this).find('> a').clone();
                var content = $(this).find('.link-box').clone();
                var nodeEdit = $(this).find('.node-edit').clone();
                $(this).find(".hover-box").append(title);
                $(this).find(".hover-box").append(content);
                $(this).find(".hover-box").find(".node-edit").remove();
                $(this).find(".hover-box").append(nodeEdit);

                $(".three-col-hoverable .col-three p").dotdotdot({
                    height: 48,
                    fallbackToLetter: true,
                    watch: true,
                })
            });
            },500);
        // }
    });
})(jQuery);
